import { Individual, IndividualCallback } from './Data';
import { FamilyTree } from './components/FamilyTree';

interface RelationalTreeProps {
    individual: Individual;
    showDetails: IndividualCallback;
}

export function Descendants({ individual, showDetails }: RelationalTreeProps) {
    return (
        <FamilyTree
            individual={individual}
            showDetails={showDetails}
            mode="descendants"
        />
    );
}

export function Ancestors({ individual, showDetails }: RelationalTreeProps) {
    return (
        <FamilyTree
            individual={individual}
            showDetails={showDetails}
            mode="ancestors"
        />
    );
}
